import { c as _c } from "react/compiler-runtime";
import { keepPreviousData, useQuery, useQueryClient } from "@tanstack/react-query";
import { ApiDrop } from "@/generated/models/ApiDrop";
import { commonApiFetch } from "@/services/api/common-api";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
interface UseDropProps {
  readonly dropId: string;
  readonly initialDrop?: ApiDrop | undefined;
  readonly enabled?: boolean | undefined;
}
const getDropQueryKey = (dropId: string) => [QueryKey.DROP, {
  drop_id: dropId
}];
const fetchDrop = (dropId: string) => commonApiFetch<ApiDrop>({
  endpoint: `drops/${dropId}`
});
export const useDrop = t0 => {
  const $ = _c(17);
  const {
    dropId,
    initialDrop,
    enabled: t1
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  const queryClient = useQueryClient();
  let t2;
  if ($[0] !== dropId) {
    t2 = getDropQueryKey(dropId);
    $[0] = dropId;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== dropId) {
    t3 = () => fetchDrop(dropId);
    $[2] = dropId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== enabled || $[5] !== initialDrop || $[6] !== t2 || $[7] !== t3) {
    t4 = {
      queryKey: t2,
      queryFn: t3,
      initialData: initialDrop,
      placeholderData: keepPreviousData,
      enabled
    };
    $[4] = enabled;
    $[5] = initialDrop;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const {
    data: drop,
    isFetching,
    refetch
  } = useQuery(t4);
  let t5;
  if ($[9] !== dropId || $[10] !== queryClient) {
    t5 = () => {
      queryClient.prefetchQuery({
        queryKey: getDropQueryKey(dropId),
        queryFn: () => fetchDrop(dropId),
        staleTime: 300000
      });
    };
    $[9] = dropId;
    $[10] = queryClient;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const prefetchDrop = t5;
  let t6;
  if ($[12] !== drop || $[13] !== isFetching || $[14] !== prefetchDrop || $[15] !== refetch) {
    t6 = {
      drop,
      isFetching,
      prefetchDrop,
      refetch
    };
    $[12] = drop;
    $[13] = isFetching;
    $[14] = prefetchDrop;
    $[15] = refetch;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};